export default __webpack_public_path__ + "static/media/hp-plans-party-popper.a11441dc.svg";